const Progress = (onUpdate, onCompleted) => {
  let index = 0;
  const imgList = [];
  let length = 0;

  const loadImages = (paths) => {
    length = paths.length;

    paths.forEach((image) => {
      const img = new Image();
      img.onload = () => {
        index += 1;
        onUpdate(index, length);
        if (index >= length) {
          onCompleted();
        }
      };
      img.src = image;
      imgList.push(img);
    });
  };

  return {
    loadImages,
  };
};

export default Progress;
